import { render, staticRenderFns } from "./TcrmDetails.vue?vue&type=template&id=1060ce58&"
import script from "./TcrmDetails.vue?vue&type=script&lang=js&"
export * from "./TcrmDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports